module.exports = __webpack_public_path__ + "static/img/icon_tp.d9243131.svg";